/**
 * Lista completa de códigos de país para selectores de teléfono.
 * Los primeros 4 (Colombia, USA, México, Venezuela) son prioritarios.
 */
export interface CountryCode {
  code: string;
  flag: string;
  name: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  // Prioritarios
  { code: "+57", flag: "🇨🇴", name: "Colombia" },
  { code: "+1", flag: "🇺🇸", name: "Estados Unidos" },
  { code: "+52", flag: "🇲🇽", name: "México" },
  { code: "+58", flag: "🇻🇪", name: "Venezuela" },
  // Resto de América Latina
  { code: "+54", flag: "🇦🇷", name: "Argentina" },
  { code: "+591", flag: "🇧🇴", name: "Bolivia" },
  { code: "+55", flag: "🇧🇷", name: "Brasil" },
  { code: "+56", flag: "🇨🇱", name: "Chile" },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { code: "+53", flag: "🇨🇺", name: "Cuba" },
  { code: "+593", flag: "🇪🇨", name: "Ecuador" },
  { code: "+503", flag: "🇸🇻", name: "El Salvador" },
  { code: "+502", flag: "🇬🇹", name: "Guatemala" },
  { code: "+509", flag: "🇭🇹", name: "Haití" },
  { code: "+504", flag: "🇭🇳", name: "Honduras" },
  { code: "+876", flag: "🇯🇲", name: "Jamaica" },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua" },
  { code: "+507", flag: "🇵🇦", name: "Panamá" },
  { code: "+595", flag: "🇵🇾", name: "Paraguay" },
  { code: "+51", flag: "🇵🇪", name: "Perú" },
  { code: "+1", flag: "🇵🇷", name: "Puerto Rico" },
  { code: "+1", flag: "🇩🇴", name: "República Dominicana" },
  { code: "+598", flag: "🇺🇾", name: "Uruguay" },
  // América del Norte y Caribe
  { code: "+1", flag: "🇨🇦", name: "Canadá" },
  // Europa
  { code: "+34", flag: "🇪🇸", name: "España" },
  { code: "+44", flag: "🇬🇧", name: "Reino Unido" },
  { code: "+33", flag: "🇫🇷", name: "Francia" },
  { code: "+49", flag: "🇩🇪", name: "Alemania" },
  { code: "+39", flag: "🇮🇹", name: "Italia" },
  { code: "+351", flag: "🇵🇹", name: "Portugal" },
  { code: "+31", flag: "🇳🇱", name: "Países Bajos" },
  { code: "+32", flag: "🇧🇪", name: "Bélgica" },
  { code: "+41", flag: "🇨🇭", name: "Suiza" },
  { code: "+43", flag: "🇦🇹", name: "Austria" },
  { code: "+46", flag: "🇸🇪", name: "Suecia" },
  { code: "+47", flag: "🇳🇴", name: "Noruega" },
  { code: "+45", flag: "🇩🇰", name: "Dinamarca" },
  { code: "+358", flag: "🇫🇮", name: "Finlandia" },
  { code: "+7", flag: "🇷🇺", name: "Rusia" },
  { code: "+380", flag: "🇺🇦", name: "Ucrania" },
  { code: "+48", flag: "🇵🇱", name: "Polonia" },
  { code: "+420", flag: "🇨🇿", name: "República Checa" },
  { code: "+36", flag: "🇭🇺", name: "Hungría" },
  { code: "+40", flag: "🇷🇴", name: "Rumanía" },
  { code: "+30", flag: "🇬🇷", name: "Grecia" },
  // Resto del mundo
  { code: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "+64", flag: "🇳🇿", name: "Nueva Zelanda" },
  { code: "+81", flag: "🇯🇵", name: "Japón" },
  { code: "+82", flag: "🇰🇷", name: "Corea del Sur" },
  { code: "+86", flag: "🇨🇳", name: "China" },
  { code: "+91", flag: "🇮🇳", name: "India" },
  { code: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "+63", flag: "🇵🇭", name: "Filipinas" },
  { code: "+66", flag: "🇹🇭", name: "Tailandia" },
  { code: "+84", flag: "🇻🇳", name: "Vietnam" },
  { code: "+60", flag: "🇲🇾", name: "Malasia" },
  { code: "+65", flag: "🇸🇬", name: "Singapur" },
  { code: "+27", flag: "🇿🇦", name: "Sudáfrica" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "+20", flag: "🇪🇬", name: "Egipto" },
  { code: "+212", flag: "🇲🇦", name: "Marruecos" },
  { code: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "+254", flag: "🇰🇪", name: "Kenia" },
  { code: "+255", flag: "🇹🇿", name: "Tanzania" },
  { code: "+90", flag: "🇹🇷", name: "Turquía" },
  { code: "+972", flag: "🇮🇱", name: "Israel" },
  { code: "+971", flag: "🇦🇪", name: "Emiratos Árabes" },
  { code: "+966", flag: "🇸🇦", name: "Arabia Saudita" },
];
